<template>
  <div :class="readOnlyProp?'btn-group display-only' : 'btn-group' " style="margin:0" data-toggle="buttons">
    <label class="btn btn-default"
           :disabled="readOnlyProp"
           @click="updateValue('Y')"
           :class="{'active': isYes}">
      <input type="radio" value="Y"
             :checked="!readOnlyProp && isYes"/> Yes
    </label>
    <label class="btn btn-default"
           :disabled="readOnlyProp"
           @click="updateValue('N')"
           :class="{'active': !isYes}">
      <input type="radio" value="N"
             :checked="!readOnlyProp && !isYes"/> No
    </label>
  </div>
</template>

<script>
  export default {
    name: 'yes-no-input',
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: '',
      readOnlyProp: Boolean
    },
    computed: {
      isYes () {
        return this.value === 'Y'
      }
    },
    methods: {

      updateValue (value) {
        if (this.readOnlyProp) {
          return
        }
        this.$emit('change', value)
      }
    }
  }
</script>

<style scoped>

  .btn-default.active, .btn-default.active.focus, .btn-default.active:hover, .btn-default:active, .btn-default:hover, .open>.btn-default.dropdown-toggle {
    color: #fff;
    background-color: #337ab7;
    border-color: #2e6da4;
  }


  .btn-group.display-only label.btn {
    pointer-events: none;
    cursor: not-allowed;
  }
  .btn-group.display-only label.btn.active {
    opacity: 1;
    color: #ffffff;
    background-color: #c3c1c1;
    border-color: #adadad;webkit-box-shadow: inset 0 3px 5px rgba(234, 152, 152, 0.12);
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.12);
  }


</style>



// WEBPACK FOOTER //
// src/js/components/YesNoButtonGroupComponent.vue